// extracted by mini-css-extract-plugin
export default {"groupContainer":"_2JRqp0uF8puycLKdoUTyqx","container":"_1COsxmq0kksZRSC8RuMV3B"};